module.exports = __webpack_public_path__ + "static/img/mt.a816f3a2.svg";